import React, {useEffect, useState} from 'react'
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { PassedMonths,ChangeSimpleDateString,GetChildrenState,GetDateWeeksString,remainDays,GetMonthDateString } from "../../components/common/Common";

import calendarIcon from "../../img/icon/icon-calendar.svg";
import kidsIcon from "../../img/icon/icon-kids.svg";
/* import cancelIcon from "../../img/icon/icon-cancel.svg"; */
import main01Icon from "../../img/icon/icon-center-main01.svg";

//보강수업 상세 현황
const ReinForceStudy = () => {
  const { ch_idx,cl_idx } = useParams();
  const bh_idx = Number(localStorage.getItem("mem_branch_idx"));
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //정보저장변수
  const [varMemberInfo,setMemberInfo] = useState({}); //원생정보
  const [varClassInfo,setClassInfo] = useState({});   //수업정보
  const [varFixedList,setFixedList] = useState([]); //출석내역
  const [varRecommendList,setRecommendList] = useState([]); //출석내역

  //원생 수업상세정보 호출
  const GetClassInformation = async() => {
    const sendData = {ch_idx:ch_idx,cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_reinforce_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) setMemberInfo(datas.results[0]);
        if(datas.classInfo.length > 0) setClassInfo(datas.classInfo[0]);
        setRecommendList(datas.recommends);
        setFixedList(datas.fixed);
      } else {
        alert(datas.message);
      }
    });
  }

  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetClassInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //보강수업 참여/취소
  const onChangeReinForceHandler = async(e,items,istate) => {
    const sendData = {csc_idx:items.csc_idx,csc_clc_idx:items.csc_clc_idx,istate:istate};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_change_reinforce_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        SendPushMessage(istate);
        GetClassInformation();
      } else {
        alert(datas.message);
      }
    });
  }

  //푸시보내기
  const SendPushMessage = async (istate) => {
    let sState = "참여";
    if(istate === 0) sState = "취소";
    const pushTitle = `[마마몽떼] 보강수업에 ${sState}합니다.`;
    const pushMessage = `${varMemberInfo.ch_name}원생이 ${varClassInfo.cl_name}의 보강수업에 ${sState}합니다.`;
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Branch/ClassInformation/${cl_idx}`;
    const sendData = {mode:2,oppIdx:bh_idx,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_push_single_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
    });
  }
  

  return (
    <div className="vh-content class-view-wrap">
      <HeaderUserTitle varPageTitle={varClassInfo.csc_mode===1?"보강 수업":"참여 수업"} varBackString={'/Parents/ReinForce'}/>
      <div className="class-wrap" style={{paddingTop:"30px"}}>
        {/* 원생정보 */}
        <div className="class-info">
          <div className="class-left">
            <div>{varMemberInfo.ch_name}</div>&nbsp;&nbsp;&nbsp;
            <div>{PassedMonths(varMemberInfo.ch_birthday)+"개월"} ({ChangeSimpleDateString(varMemberInfo.ch_birthday)}) ({GetChildrenState(varMemberInfo.ch_status)})</div>      
          </div>
        </div>
        {/* 수업현황 */}
        <div className="supple-con">
          <div className="center-wrap">
            <div className="con con01">
              <div className="class-line">
                <div>총 {varClassInfo.csc_mode===1?"보강":"참여"}일 {varClassInfo.tcount}</div>˙
                <div>잔여 횟수  {varClassInfo.ycount}</div>˙
                <div>출석  {varClassInfo.ecount}</div>
              </div>
              <div className="box-wrap">
                <div className="img-box">
                  <img src={main01Icon} alt=""/>
                  <span>{varClassInfo.cl_type===1?"마마몽떼":"플라이"}<br/>{varClassInfo.cr_name}</span>
                </div>
                <div className="txt-box">
                    <p className="class-tit">{varClassInfo.cl_name}</p>
                    <div className="class-date">
                      <img src={calendarIcon} alt=""/>
                      <p>{ChangeSimpleDateString(varClassInfo.sm_sdate)} ~ {GetMonthDateString(varClassInfo.sm_edate)}</p>
                    </div>
                  <div className="class-kids">
                      <img src={kidsIcon} alt=""/>
                      <p>{varClassInfo.vl_name} ({varClassInfo.ch_attendance})</p>
                  </div>
                </div>
              </div>
              {/* 보강 수업 배정 내역 */}
              {varFixedList.map((fixed,i)=>(
                <div key={'fixed_'+i} className="con con02">
                  <div className="con-tit">{fixed.csc_mode===1?"보강":"참여"} 수업 배정 내역</div>
                  <div className="con-box">
                    <ul>
                      <li>
                        {/* <img src={cancelIcon} alt=""/> */}
                        <p>{fixed.cs_index}차 수업</p>
                        <div className="date">
                          {GetDateWeeksString(fixed.cs_date)} {fixed.cs_hour}:{fixed.cs_minute} -
                          {fixed.csc_status===2?"출석":fixed.csc_status===3?"결석":fixed.csc_status===1?"대기":"종료"}
                        </div>
                      </li>
                    </ul>
                    {fixed.csc_status===1 && remainDays(fixed.cs_date)>0?<button className="btn-no" onClick={e=>onChangeReinForceHandler(e,fixed,0)}>{fixed.csc_mode===1?"보강":"참여"} 취소 신청</button>:null}
                  </div>
                </div>
              ))}
              {/* 직접 신청가능 보강 수업 */}
              {varRecommendList.map((recommends,i)=>(
                <div key={'recommends_'+i} className="con con03">
                  <div className="con-tit">직접 신청가능 {recommends.csc_mode===1?"보강":"참여"} 수업</div>
                  <div className="con-box">
                    <ul>
                      <li>
                        {/* <img src={cancelIcon} alt=""/> */}
                        <p>{recommends.csc_mode===1?"보강":"참여"} 수업</p>
                        <div className="date">{GetDateWeeksString(recommends.cs_date)} {recommends.cs_hour}:{recommends.cs_minute}</div>
                      </li>
                    </ul>
                    <div className="btn-wrap">
                      <button className="btn-yes st02" onClick={e=>onChangeReinForceHandler(e,recommends,2)}>수업 참여</button>&nbsp;&nbsp;
                      <button className="btn-no" onClick={e=>onChangeReinForceHandler(e,recommends,0)}>수업 취소</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ReinForceStudy;